<template>
  <div class="mobile clearfix">
    <MobileHeader/>
    <div class="article-list-mobile">
      <div class="bread clearfix">
        <span>您现在的位置：</span>
        <label  >全文检索
        </label>
      </div>
      <ul class="list clearfix" >
        <li v-for="(item, index) in date1.records" :key="index" @click="jump(item.id)" >
            <h3 title="" class="text-wid">
              <a target="_blank">{{item.title}}</a>
            </h3>
            <p class="p" style="word-wrap: break-word;">
              {{item.description | ellipsis}}</p>
            <p class="date">{{item.releaseDate }}</p>
        </li>
        <!-- <li>
           <h3 title="迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话" class="text-wid">
             <a href="#" target="_blank">迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话</a>
           </h3>
           <p class="p" style="word-wrap: break-word;">为进一步加强北京协和医院学科建设，按照医院干部届中调整工作安排，在民主推荐和考察谈话的基础上，医院重新组建变态(过敏)反应科领导团队，对...</p>
           <p class="date">2020.07.17</p>
         </li>
         <li>
           <h3 title="迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话" class="text-wid">
             <a href="#" target="_blank">迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话</a>
           </h3>
           <p class="p" style="word-wrap: break-word;">为进一步加强北京协和医院学科建设，按照医院干部届中调整工作安排，在民主推荐和考察谈话的基础上，医院重新组建变态(过敏)反应科领导团队，对...</p>
           <p class="date">2020.07.17</p>
         </li>
         <li>
           <h3 title="迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话" class="text-wid">
             <a href="#" target="_blank">迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话</a>
           </h3>
           <p class="p" style="word-wrap: break-word;">为进一步加强北京协和医院学科建设，按照医院干部届中调整工作安排，在民主推荐和考察谈话的基础上，医院重新组建变态(过敏)反应科领导团队，对...</p>
           <p class="date">2020.07.17</p>
         </li>-->
      </ul>
<!--      <van-pagination v-model="date1.ipage.pages" :page-count="date1.ipage.current" mode="simple" />-->

      <div class="page-list clearfix">
        <a @click="pagination($event, date1.current-1)" >上页</a>
        &nbsp;&nbsp;&nbsp;
       <!-- <template v-for="count in date1.ipage.pages">
          <a @click="pagination($event, count)" :class="count == date1.ipage.current ? 'focus' : ''" :key="count" v-if="count<=date1.ipage.current+5 && count>date1.ipage.current-5" >{{ count }}</a>
        </template>-->
        <a @click="pagination($event, date1.current+1)" >下页</a>
        共{{date1.pages}}页 <!--跳转至<input style="width: 22px" v-model="pages" @keyup.enter="goPage()">页<a @click="goPage()">go</a>-->
      </div>

    </div>
   <!-- <div class="article-list-mobile detail clearfix">
      <div class="main clearfix">
        <h3>迈向新百年 | 协和第二批科室干部届中调整名单公布，院领导与新任科室领导团队进行任前集体谈话</h3>
        <div class="tip">
          <span>时间：<i>2020.07.17</i></span>
          <span class="viewnum_ajax">点击数：<i style="display: inline;">50</i> 次</span>
          <span>发布来源：本站原创</span>                                            </div>
      </div>
      <div class="content clearfix">
        变态(过敏)反应科新一届领导团队包括王良录常务副主任（主持工作）、孙劲旅副主任及关凯主任助理。聘任何小东同志为外科学系副主任，戴梦华同志为帅府外科主任，朱惠娟同志为临床医学博士后项目办主任，李玥同志为临床医学博士后项目办副主任。在任前集体谈话中，各位新上任科主任及主任助理逐一作了表态发言，将以促进学科发展和科室人才梯队建设为己任，围绕医疗安全和医疗质量的核心，努力带领科室迈向新的发展阶段。
      </div>

    </div>-->
    <MobileFooter/>
  </div>
</template>

<script>

  import MobileHeader from './MobileHeader.vue'
  import MobileFooter from "./MobileFooter";
  import _http from "../httpService";

  export default {
    name: "HospitalSummedup",
    components: {
      MobileHeader,
      MobileFooter
    },
    data(){
      return {
        pageNo: 1,
        pages:1,
        pageSize: 10,
        date1: {
          ipage: {},
          channelName: "",
          channelNameEn: "",
          channelContent: "",
        },
        dataList: [],
        isDisable: false,
        name: "",
        mobile: "",
        content: "",
      };
    },
    methods:{
      filters: {
        ellipsis (value) {
          if (!value) return ''
          if (value.length > 20) {
            return value.slice(0,20) + '...'
          }
          return value
        }
      },
      jump: function(id) {
        this.$router.push({ path: "/MobileArticle/" + id });
      },
      pagination: function(e, pageNo) {
        this.pageNo = pageNo
        _http.get("/content/jcContent/listArticle?channelCode=" +this.$route.query.channelCode +"&pageNo=" +pageNo +
                        "&pageSize=" +this.pageSize
                )
                .then((resp) => {
                  if (resp.data.success) {
                    this.date1 = resp.data.result;
                  }
                })
                .catch((error) => console.log(error))
                .finally(() => (this.loading = false));
      },
    },
    watch: {
      //监听相同路由下参数变化的时候，从而实现异步刷新
      $route() {
        console.log(this.$route.query);
        _http .get( "/content/jcContent/fullTextSearch?channelname=" +
                        this.$route.query.keyWord + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize
                )
                .then((resp) => {
                  if (resp.data.success) {
                    console.log(resp.data);
                    if(resp.data.result.total == 0) {
                      this.notFind = "没有找到搜索的内容"
                      this.date1 = []
                    }
                    else {
                      this.date1 = resp.data.result;
                      this.notFind = "";
                    }
                  }
                })
                .catch((error) => console.log(error))
                .finally(() => (this.loading = false));
      },
      immediate: true,
    },
  }
</script>

<style scoped>

</style>
